export default __webpack_public_path__ + "static/media/dare_img.68fd5ecb.svg";